import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import CheckboxOption from "csi/middleware/customView/options/CheckboxOption";
import { isDefined } from "csi/utility/coreUtility";
import { Box, FlexColumn, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import css from "src/csi/middleware/customView/options/CustomViewOptions.module.css";
import DisplayCommentLines from "../../csi/middleware/customView/options/DisplayCommentLines";
import SizeChartTableCustomViewOptionsStore from "./SizeChartTableCustomViewOptionsStore";

const SizeChartTableOptions: FunctionComponent = observer(function SizeChartTableOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		onChangeSizeChartCompare,
		onChangeSizeChartDimensionFormat,
		onChangeSizeChartDisplay,
		onChangeSizeChartOptions,
		onChangeSizeChartUnits,
		selectedSizeChartCompare,
		selectedSizeChartDimensionFormat,
		selectedSizeChartIncrementDisplay,
		selectedSizeChartOption,
		selectedSizeChartUnits,
		setDisplayCommentLines,
		setSizeChartHighlightActualOutOfTolerance,
		setSizeChartHighlightBlank,
		setSizeChartHighlightBlankTolerance,
		setSizeChartHighlightDeltaOutOfTolerance,
		setSizeChartHighlightRevisedDeltaOutOfTolerance,
		options: {
			displayCommentLines,
			sizeChartHighlightActualOutOfTolerance,
			sizeChartHighlightBlank,
			sizeChartHighlightBlankTolerance,
			sizeChartHighlightDeltaOutOfTolerance,
			sizeChartHighlightRevisedDeltaOutOfTolerance,
		},
		sizeChartDropDownOptions: {
			sizeChartCompareOptions,
			sizeChartDimensionFormatOptions,
			sizeChartDisplayOptions,
			sizeChartIncrementDisplayOptions,
			sizeChartUnitsOptions,
		},
	} = optionsStore as SizeChartTableCustomViewOptionsStore;

	return (
		<>
			{isDefined(selectedSizeChartIncrementDisplay) && (
				<Box className={css.container}>
					<FlexColumn 
						className={css.optionLeft}
						data-csi-automation="CustomViewIncrementDisplay"
					>
						<SingleSelect
							disableClearable
							fullWidth
							labelRes="CustomViewIncrementDisplay"
							onChange={onChangeSizeChartDisplay}
							options={sizeChartIncrementDisplayOptions}
							value={selectedSizeChartIncrementDisplay}
						/>
					</FlexColumn>
				</Box>
			)}
			{isDefined(selectedSizeChartCompare) && (
				<Box className={css.container}>
					<FlexColumn 
						className={css.optionLeft}
						data-csi-automation="CustomViewSizeChartCompare"
					>
						<SingleSelect
							disableClearable
							fullWidth
							labelRes="ViewPreferences_sizeChartCompare"
							onChange={onChangeSizeChartCompare}
							options={sizeChartCompareOptions}
							value={selectedSizeChartCompare}
						/>
					</FlexColumn>
				</Box>
			)}
			{isDefined(selectedSizeChartUnits) && (
				<Box className={css.container}>
					<FlexColumn 
						className={css.optionLeft}
						data-csi-automation="SizeChartPasteUnits"
					>
						<SingleSelect
							disableClearable
							fullWidth
							labelRes="SizeChartPasteUnits"
							onChange={onChangeSizeChartUnits}
							options={sizeChartUnitsOptions}
							value={selectedSizeChartUnits}
						/>
					</FlexColumn>
				</Box>
			)}
			{isDefined(selectedSizeChartDimensionFormat) && (
				<Box className={css.container}>
					<FlexColumn 
						className={css.optionLeft}
						data-csi-automation="SizeChartDimensionFormat"
					>
						<SingleSelect
							disableClearable
							fullWidth
							labelRes="ViewPreferences_SizeChartDimensionFormat"
							onChange={onChangeSizeChartDimensionFormat}
							options={sizeChartDimensionFormatOptions}
							value={selectedSizeChartDimensionFormat}
						/>
					</FlexColumn>
				</Box>
			)}
			{isDefined(selectedSizeChartOption) && (
				<Box className={css.container}>
					<FlexColumn 
						className={css.optionLeft}
						data-csi-automation="SizeChartDisplayOptions"
					>
						<SingleSelect
							disableClearable
							fullWidth
							labelRes="SizeChartDisplayOptions"
							onChange={onChangeSizeChartOptions}
							options={sizeChartDisplayOptions}
							value={selectedSizeChartOption}
						/>
					</FlexColumn>
				</Box>
			)}
			<DisplayCommentLines
				onChange={setDisplayCommentLines}
				value={displayCommentLines}
			/>
			<CheckboxOption
				dataCsiAutomation="CustomViewSizeChartHighlightBlankTolerance"
				label="CustomViewSizeChartHighlightBlankTolerance"
				onChange={setSizeChartHighlightBlankTolerance}
				optionValue={sizeChartHighlightBlankTolerance}
				paddingLeft={0}
			/>
			<CheckboxOption
				dataCsiAutomation="CustomViewSizeChartHighlightActualOutOfTolerance"
				label="CustomViewSizeChartHighlightActualOutOfTolerance"
				onChange={setSizeChartHighlightActualOutOfTolerance}
				optionValue={sizeChartHighlightActualOutOfTolerance}
				paddingLeft={0}
			/>
			<CheckboxOption
				dataCsiAutomation="CustomViewSizeChartHighlightDeltaOutOfTolerance"
				label="CustomViewSizeChartHighlightDeltaOutOfTolerance"
				onChange={setSizeChartHighlightDeltaOutOfTolerance}
				optionValue={sizeChartHighlightDeltaOutOfTolerance}
				paddingLeft={0}
			/>
			<CheckboxOption
				dataCsiAutomation="CustomViewSizeChartHighlightBlank"
				label="CustomViewSizeChartHighlightBlank"
				onChange={setSizeChartHighlightBlank}
				optionValue={sizeChartHighlightBlank}
				paddingLeft={0}
			/>
			<CheckboxOption
				dataCsiAutomation="CustomViewSizeChartHighlightRevisedDeltaOutOfTolerance"
				label="CustomViewSizeChartHighlightRevisedDeltaOutOfTolerance"
				onChange={setSizeChartHighlightRevisedDeltaOutOfTolerance}
				optionValue={sizeChartHighlightRevisedDeltaOutOfTolerance}
				paddingLeft={0}
			/>
		</>
	);
});

export default SizeChartTableOptions;